import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { FileListComponent } from './file-list/file-list.component';
import { FileListItemComponent } from './file-list/file-list-item/file-list-item.component';
import { UploadDialogComponent } from './upload-dialog/upload-dialog.component';
import { PhoenixPipesModule } from '../../../pipes/pipes';
import { AttachmentsComponent } from './attachmentsComponent/attachments.component';
import { UrlDialogComponent } from './url-dialog/url-dialog.component';
import {
  DxFileManagerModule,
  DxLoadPanelModule,
  DxPopupModule,
  DxButtonModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { ValidationErrorsModule } from 'app/components/validation-errors/validation-errors.module';

@NgModule({
    declarations: [
        FileListComponent,
        FileListItemComponent,
        FileManagerComponent,
        AttachmentsComponent,
        UploadDialogComponent,
        UrlDialogComponent,
    ],
    imports: [
        DxFileManagerModule,
        DxLoadPanelModule,
        DxPopupModule,
        DxButtonModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxToolbarModule,
        MatButtonModule,
        MatCheckboxModule,
        MatListModule,
        MatProgressBarModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MatDividerModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatChipsModule,
        CommonModule,
        PhoenixPipesModule,
        FuseSharedModule,
        PhoenixDirectivesModule,
        ValidationErrorsModule,
    ],
    providers: [],
    exports: [
        FileListComponent,
        FileListItemComponent,
        FileManagerComponent,
        AttachmentsComponent,
        UploadDialogComponent,
        UrlDialogComponent,
    ]
})
export class FilesModule {}
